import React, {useEffect, useState} from 'react';
import {
    Box,
    Button,
    Card,
    CardActionArea,
    Dialog,
    DialogContent,
    DialogTitle,
    Grid,
    IconButton,
    Typography
} from '@mui/material';
import {MdBlock, MdBusiness, MdClose, MdGavel, MdGroups, MdHowToReg, MdLanguage, MdPerson} from 'react-icons/md';
import {jwtDecode} from "jwt-decode";

const entityOptions = [
    {key: 'physical', label: 'ფიზიკური პირი', icon: <MdPerson size={48} color="#3872F2"/>},
    {key: 'legal', label: 'კერძო სამართლის იურიდიული პირი', icon: <MdBusiness size={48} color="#3872F2"/>},
    {key: 'association', label: 'საჯარო სამართლის იურიდიული პირი', icon: <MdGavel size={48} color="#3872F2"/>},
    {key: 'association', label: 'ამხანაგობა და სხვა', icon: <MdGroups size={48} color="#3872F2"/>},
    {key: 'foreigner', label: 'უცხო ქვეყნის მოქალაქე', icon: <MdLanguage size={48} color="#3872F2"/>},
    {key: 'self_customer', label: 'მე ვარ დამკვეთი', icon: <MdHowToReg size={48} color="#3872F2"/>}
];

const secondStepOptions = [
    {key: 'physical', label: 'ფიზიკური პირი', icon: <MdPerson size={48} color="#3872F2"/>},
    {key: 'legal', label: 'კერძო სამართლის იურიდიული პირი', icon: <MdBusiness size={48} color="#3872F2"/>},
    {key: 'association', label: 'საჯარო სამართლის იურიდიული პირი', icon: <MdGavel size={48} color="#3872F2"/>},
    {key: 'association', label: 'ამხანაგობა და სხვა', icon: <MdGroups size={48} color="#3872F2"/>},
    {key: 'foreigner', label: 'უცხო ქვეყნის მოქალაქე', icon: <MdLanguage size={48} color="#3872F2"/>},
    // {key: 'self_customer', label: 'მე ვარ ექსპლუატაციის გამწევი პირი', icon: <MdHowToReg size={48} color="#3872F2"/>},
    {key: 'without_exploitation', label: 'არ მყავს ექსპლუატაციის გამწევი პირი', icon: <MdBlock size={48} color="#3872F2"/>}
];

const EntitySelectorDialog = ({open, onClose, onSelect, hasSecondStep}) => {
    const token = localStorage.getItem("jwtToken");
    const [userRole, setUserRole] = useState(null);

    useEffect(() => {
        if (token) {
            try {
                const decoded = jwtDecode(token);
                setUserRole(decoded.role);
            } catch (error) {
                setUserRole("");
            } finally {
            }
        }
    }, [token]);
    const [step, setStep] = useState(1);
    const handleSelect = key => {
        if (hasSecondStep && step === 1) {
            onSelect(key, 1);
            setStep(2);
        } else {
            onSelect(key, 2);
            setStep(1);
        }
    };


    const options = (step === 1 ? entityOptions : secondStepOptions).filter(opt => {
        if (userRole === 'ROOTADMIN' && step === 1 && opt.key === 'self_customer') return false;
        return !(step === 2 && opt.key === 'self_customer');

    });



    return (
        <Dialog open={open} onClose={() => {
            onClose();
            setStep(1);
        }} maxWidth="sm" fullWidth>
            <DialogTitle sx={{m: 0, p: 2}}>
                <IconButton
                    onClick={() => {
                        onClose();
                        setStep(1);
                    }}
                    sx={{position: 'absolute', right: 12, top: 0, color: '#999'}}
                >
                    <MdClose/>
                </IconButton>
            </DialogTitle>
            <DialogContent>
                {step === 1 && (
                    <Typography variant="h6" fontWeight={600} textAlign="center" mb={2} color="primary">
                        დამკვეთი
                    </Typography>
                )}
                {step === 2 && (
                    <Typography variant="h6" fontWeight={600} textAlign="center" mb={2} color="primary">
                        ექსპლუატაციის გამწევი პირი
                    </Typography>
                )}

                <Box mb={5}>
                    {step === 2 && (
                        <Button variant="outlined" onClick={() => setStep(1)}>← დაბრუნება</Button>
                    )}
                </Box>


                <Grid container spacing={3} justifyContent="center">
                    {options.map(({key, label, icon}) => (
                        <Grid key={key} item xs={12} sm={6}>
                            <Card
                                elevation={4}
                                sx={{
                                    height: 180,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    borderRadius: 4,
                                    transition: 'transform 0.2s, box-shadow 0.2s',
                                    '&:hover': {transform: 'scale(1.05)', boxShadow: 6}
                                }}
                            >
                                <CardActionArea
                                    onClick={() => handleSelect(key)}
                                    sx={{
                                        height: '100%',
                                        p: 3,
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        gap: 1
                                    }}
                                >
                                    {icon}
                                    <Typography variant="h6" fontWeight={500} textAlign="center">
                                        {label}
                                    </Typography>
                                </CardActionArea>
                            </Card>
                        </Grid>
                    ))}
                </Grid>
            </DialogContent>
        </Dialog>
    );
};

export default EntitySelectorDialog;
